<template>

<div class="ew-page">
  <navbar-dashboard name="Reporte General"></navbar-dashboard>

  <div class="ew-page__body">
    <b-modal ref="editOverWeight" hide-footer title="Editar sobrepeso" modal-class="ew-modal">
          <form @submit.prevent="updateOverWeight" class="ew-form">
            <p class="alert alert-danger ew-alert" role="alert" v-if="overWeightError">{{ overWeightError }}</p>
            <div class="ew-form__field">
              <label class="ew-label" for="ow-input">Sobrepeso (kg) *</label>
              <input id="ow-input" type="number" class="ew-input ew-input--block" placeholder="0.0" v-model="overweight" required>
            </div>
            <div class="ew-form__field">
              <label class="ew-label" for="ow-cost-input">Costo *</label>
              <input id="ow-cost-input" type="number" class="ew-input ew-input--block" placeholder="0.00" v-model="cost_overweight" required>
            </div>
            <div class="ew-modal__actions">
              <button type="button" class="ew-btn-outline" @click="hideModalOverWeight">Cancelar</button>
              <button v-if="overweight_paid == false || overweight_paid == null" class="ew-btn-primary" type="submit" :disabled="overWeightSaving">
                {{ overWeightSaving ? 'Guardando…' : 'Guardar cambios' }}
              </button>
            </div>
          </form>
    </b-modal>

    <b-tabs pills class="ew-tabs">
      <b-tab title="Envíos Web" active>

              <b-alert :show="dismissCountDown"
                    dismissible
                    variant="success"
                    @dismissed="dismissCountDown=0"
                    @dismiss-count-down="countDownChanged"
                    class="ew-alert">
                {{message}}
              </b-alert>

              <div class="ew-toolbar ew-toolbar--end">
                <json-excel class="ew-btn-outline" :fetch="actualizaShipmentsExport" type="csv" title="Exportar" name="shipments.xls">Exportar</json-excel>
              </div>

              <section class="ew-card">
                <div class="ew-filters">
                  <span class="ew-filters__label"><ph-icon name="funnel" />Seleccione periodo</span>

                  <div class="ew-filters__row-top">
                    <div class="ew-date-range">
                      <datepicker :bootstrap-styling="false"
                                  input-class="ew-input"
                                  :open-date="openDate"
                                  :format="customFormatter"
                                  :disabled-dates="{ from: new Date() }"
                                  v-model="date_ini"
                                  @closed="onManualDateChange">
                      </datepicker>
                      <span class="ew-date-range__sep">–</span>
                      <datepicker :bootstrap-styling="false"
                                  input-class="ew-input"
                                  :open-date="openDate"
                                  :format="customFormatter"
                                  :disabled-dates="{ from: new Date() }"
                                  v-model="date_fin"
                                  @closed="onManualDateChange"
                              >
                      </datepicker>
                    </div>

                    <div class="ew-date-presets">
                      <button type="button" class="ew-date-presets__btn" :class="{'is-active': activeDatePreset === 'today'}" @click="setDateRange('today')">Hoy</button>
                      <button type="button" class="ew-date-presets__btn" :class="{'is-active': activeDatePreset === '7d'}" @click="setDateRange('7d')">Últimos 7 días</button>
                      <button type="button" class="ew-date-presets__btn" :class="{'is-active': activeDatePreset === 'month'}" @click="setDateRange('month')">Este mes</button>
                    </div>
                  </div>

                  <form class="ew-filters__row" @submit.prevent>
                    <select class="ew-select" v-model.trim="selectedService" @change="filterShipmentsByCarriersServices(selectedService)">
                      <option selected>Servicios</option>
                      <option v-for="c in availableCarriers" :value="c" :key="c" >{{ carrierAndServiceCarrier(c) }}</option>
                    </select>

                    <select class="ew-select" v-model.trim="guideStatusFilter" @change="filterShipmentsByGuideStatus(guideStatusFilter)">
                      <option value="all">Estatus de pago</option>
                      <option value="false">Guía sin pago</option>
                      <option value="true">Pagado</option>
                    </select>

                    <div class="ew-filters__search">
                      <input type="text" class="ew-input ew-filters__keyword" placeholder="Palabra clave..." v-model="searchByKeywordCriteria" @keyup.enter="filterShipments(searchByKeywordCriteria)">
                      <span class="ew-filters__search-spinner" v-if="searching"></span>
                    </div>
                  </form>

                  <div class="ew-filters__badges" v-if="filter.length > 0">
                    <span class="ew-badge" v-for="(c, i) in filter" :key="i">
                      {{printBadge(c)}}
                      <ph-icon name="x" @click.native="deletebadg(i)" />
                    </span>
                  </div>
                </div>

                <div class="table-responsive">
                  <div class="ew-loading" v-if="dataLoading">
                    <span class="ew-spinner"></span>
                    <p class="ew-loading-text">Cargando…</p>
                  </div>
                  <div class="ew-empty" v-else-if="loadError">
                    <ph-icon name="x" />
                    <p class="ew-empty__title">No se pudo cargar la información</p>
                    <p class="ew-empty__text">Ocurrió un problema al consultar el servidor. Intenta de nuevo en unos segundos.</p>
                    <button type="button" class="ew-btn-primary" @click="getAllShipmentsByDates">Reintentar</button>
                  </div>
                  <table class="ew-table" v-else-if="shipments.docs && shipments.docs.length > 0">
                    <thead>
                      <tr>
                         <th scope="col">Fecha</th>
                          <th scope="col">Usuario</th>
                          <th scope="col">Nombre origen</th>
                        <th scope="col">Servicio</th>
                        <th scope="col">Medidas</th>
                        <th scope="col">Peso</th>
                        <th scope="col">N° de guía</th>
                        <th scope="col">Estatus guía</th>
                        <th scope="col">Total</th>
                        <th scope="col">Guía</th>
                        <th scope="col">Acciones</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(s, i) in shipments.docs" v-bind:key="i">
                         <td>{{ formatDate(s.created_at)}}</td>
                         <td>
                           <div class="ew-user-cell" v-if="s.customer_info != null" :title="s.user">
                             <strong class="ew-user-cell__name">{{ s.customer_info.first_names }} {{ s.customer_info.last_names }}</strong>
                             <span class="ew-user-cell__email">{{ s.customer_info.email }}</span>
                           </div>
                           <span class="ew-user-cell__id" v-else>{{ s.user }}</span>
                         </td>
                         <td>{{s.origin_direction.full_name}}</td>
                         <td>{{ s.selected_service.carrier }} -
                        {{ localCapitalize(s.selected_service.carrier_service_name)}}</td>
                        <td class="ew-table__cell--muted">{{ s.parcels[0].height }} x {{ s.parcels[0].width }} x {{ s.parcels[0].depth }} cm</td>
                        <td class="ew-table__cell--muted">{{ s.parcels[0].weight }} kg</td>
                        <td>
                          <div class="ew-guide-cell">
                            <span class="ew-guide-cell__number">{{ numberGuide(s.number_guide) }}</span>
                            <span class="ew-guide-cell__meta" v-if="s.numberOfOrder">Orden {{ s.numberOfOrder }}</span>
                            <span class="ew-guide-cell__meta" v-if="s.reference">Ref {{ s.reference }}</span>
                          </div>
                        </td>
                        <td>{{obtenerStatus(s)}}</td>
                        <td class="ew-table__amount" :class="{'is-pending': !s.status, 'is-paid': s.status}">
                          <small>{{ s.selected_service.currency }}</small> {{ s.selected_service.total_amount }}
                        </td>
                        <td>
                          <a :href="downloadTracking(s)" download :class="{disabled: !s.status}" target="_blank" class="ew-table__pdf-link">
                              <img src="@/assets/images/pdf-icon.svg" v-if="s.status" class="ew-icon-pdf" alt="Descargar guía">
                              <img src="@/assets/images/pdf-icon-grey.svg" v-else class="ew-icon-pdf" alt="Guía aún no disponible">
                          </a>
                        </td>
                        <td class="ew-table__actions">
                          <button class="ew-icon-btn" @click="gotoShipmentDetails(s._id)" aria-label="Ver detalle" title="Ver detalle">
                            <ph-icon name="magnifying-glass" />
                          </button>
                          <button v-if="isAdmin" class="ew-icon-btn" @click="editOverWeight(s._id, s.overweight, s.cost_overweight, s.overweight_paid)" aria-label="Editar sobrepeso" title="Editar sobrepeso">
                            <ph-icon name="scales" />
                          </button>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <div class="ew-empty" v-else>
                    <ph-icon name="package" />
                    <p class="ew-empty__title">Sin envíos en este periodo</p>
                    <p class="ew-empty__text">Ajusta el rango de fechas o los filtros para ver más resultados.</p>
                  </div>
                </div>

                <div class="ew-pagination" v-if="shipments.docs && shipments.docs.length > 0">
                  <button class="ew-pagination__btn" @click="previousPage">Anterior</button>
                  <button class="ew-pagination__btn" @click="goToPage(p)" v-for="p in availablePages(shipments.page)" :key="p" :class="{'is-active': shipments.page === p }">{{ p }}</button>
                  <button class="ew-pagination__btn" @click="nextPage">Siguiente</button>
                </div>
              </section>

              <b-modal ref="myModalRef" id="modalcenter" centered title="Información preventiva" hide-footer modal-class="ew-modal">
                  <p class="ew-modal__text">Has seleccionado un envío que ya ha sido pagado; te invitamos a desmarcar las casillas correspondientes para poder continuar con tu operación.</p>
                  <div class="ew-modal__actions">
                    <button class="ew-btn-primary" @click="hideModal">Entendido</button>
                  </div>
              </b-modal>
      </b-tab>
      <!--<b-tab title="E-Commerce">
         <div class="row justify-content-between no-gutters">
                <div class="col-md-auto">

                </div>

                <div class="col-md-auto">
                  <router-link class="btn btn-primary mb-3 mr-0 px-4 py-2" to="/dashboard/shipment/new">Nuevo envío</router-link>
                </div>
              </div>

              <div class="ew-conten-table pt-4 pl-2 pr-2">
                <div class="mb-5 px-3">
                  <div class="mb-2">Filtrar busqueda por:</div>
                  <form @submit.prevent >
                    <div class="row">
                      <div class="col-md-6">
                        <input type="text" class="form-control" placeholder="Palabra clave..." v-model="key">
                      </div>
                    </div>
                  </form>
                </div>

                <div class="table-responsive ew-content-tabel">
                  <table class="table">
                    <thead>
                      <tr>
                        <th scope="col">Nombre</th>
                        <th scope="col">Destino</th>
                        <th scope="col">Servicio</th>
                        <th scope="col">N° de guía</th>
                        <th scope="col">Estatus guía</th>
                        <th scope="col">Total</th>
                        <th scope="col">Guía</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(s, i) in marketplaceList" v-bind:key="i" @click="gotoShipmentEcommerce(i)">
                        <td @click.stop>{{ s.destination_direction.full_name }}</td>
                        <td @click.stop>{{ s.destination_direction.address }}</td>
                        <td @click.stop>--</td>
                        <td @click.stop>--</td>
                        <td @click.stop>--</td>
                        <td @click.stop>--</td>
                        <td class="text-primary font-weight-bold">Generar Guia</td>
                        </tr>
                    </tbody>
                  </table>

                </div>
              </div>
              <b-modal ref="myModalRef" id="modalcenter" centered title="Información Preventiva" hide-footer>
                  <p class="my-4 text-justify" >A seleccionado un envio que ya ha sido pago, le invitamos a que desmarque las casillas correspondientes para poder continuar con su operación.</p>
                  <div class="row">
                      <div class="col-md">
                        <p class="text-right mt5">
                          <button class="btn btn-primary" @click="hideModal" >Cancelar</button>
                        </p>
                      </div>
                  </div>
              </b-modal>
      </b-tab>-->
    </b-tabs>
  </div>
</div>

</template>

<script>
import Navbar from './Header/Navbar'
import { mapGetters, mapActions, mapMutations } from 'vuex'
import api from '../commons/api'
import axios from 'axios'
import commons from '../commons'
import moment from 'moment'
import Datepicker from 'vuejs-datepicker';
import JsonExcel from "vue-json-excel";
import PhIcon from './icons/PhIcon'

export default {
  name: 'Dashboard',

  data () {
    return {
      key:'',
      dataLoading: true,
      searching: false,
      loadError: false,
      activeDatePreset: '7d',
      statusGuide:[],
      message:"",
      dismissSecs: 5,
      dismissCountDown: 0,
      selected: [],
      currentPage: 1,
      searchByKeywordCriteria: '',
      guideStatusFilter: 'all',
      paquetes:'all',
      availableCarriers: [],
      selectedService: 'Servicios',
      filterShipmentsTimeoutID: '',
      filter:[],
      services:{
        dhl:["EXPRESS DOMESTIC 10:30","EXPRESS DOMESTIC", "EXPRESS DOMESTIC DINAMICA", "EXPRESS DOMESTIC 12:00", "ECONOMY SELECT DOMESTIC","EXPRESS DOMESTIC FLAT", "SAMEDAY SPRINTLINE"],
        redpack:["ECOEXPRESS"],
        ampm: ["ESTANDAR", "EXPRESS"],
        estafeta: ["Envío Economico","Envío Express", "TERRESTRE", "DIA SIG"]
      },
      date_ini: new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate() - 6),
      openDate: new Date(),
      date_fin: new Date(),
      service: '',
      status: '',
      shipmentsExport: [],
      shipmentId: '',
      overweight: '',
      cost_overweight: '',
      overweight_paid: false,
      overWeightError: '',
      overWeightSaving: false
    }
  },

  created () {
    this.setNewShipmentEcommerce(null);
    this.getUser()
    Tawk_API.onLoad = function(){
        Tawk_API.showWidget()
        Tawk_API.minimize()
    };
    this.getAllShipmentsByDates()
    this.getMarketplace()
    this.getAllAvailableCarriers()

  },
  mounted(){
    try {
      Tawk_API.showWidget()
      Tawk_API.minimize()
    } catch (error) {

    }
  },
  beforeDestroy(){
    Tawk_API.hideWidget()
  },
  methods: {
    carrierAndServiceCarrier(serviceCarrier){
      if (this.services.dhl.includes(serviceCarrier)) {
        return `DHL - ${this.localCapitalize(serviceCarrier)}`
      } else if(this.services.redpack.includes(serviceCarrier)){
        return `Redpack - ${this.localCapitalize(serviceCarrier)}`
      } else if(this.services.ampm.includes(serviceCarrier)){
        return `AMPM - ${this.localCapitalize(serviceCarrier)}`
      }
      else if(this.services.estafeta.includes(serviceCarrier)){
       return `Estafeta - ${this.localCapitalize(serviceCarrier)}`
      }
      else{
        return `Fedex - ${this.localCapitalize(serviceCarrier)}`
      }
    },
    statusShipments(){
      let status = false
      this.selected.forEach(element => {
          if (element.status) {
            status = true
          }
      });
      return status
    },
    showModal () {
      this.$refs.myModalRef.show()
    },
    hideModal () {
      this.$refs.myModalRef.hide()
    },
    localCapitalize(string){
      return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
    },
    numberGuide(number, status, i){
      if (number !== null) {
        return number
      } else {
        return "Sin numero de guia"
      }
    },
    obtenerStatus(shipment)
    {
      if (shipment.number_guide == null) {
        return "Sin guía"
      }
      return shipment.tracking_status || "Sin verificar"
    },
    editOverWeight(id,overweight,cost_overweight, overweight_paid)
    {
      this.shipmentId = id
      this.overweight = overweight
      this.cost_overweight = cost_overweight
      this.overweight_paid = overweight_paid
      this.showModalOverWeight()
    },
    hideModalOverWeight () {
      this.$refs.editOverWeight.hide()
    },
    showModalOverWeight () {
      this.$refs.editOverWeight.show()
    },
    updateOverWeight(id,overweight)
    {
        this.overWeightError = ''
        this.overWeightSaving = true
        axios
          .put(`${commons.apiURL}/api/v1/shipments/${this.shipmentId}`, {
            overweight: this.overweight,
            cost_overweight: this.cost_overweight
          })
          .then(response => {
              if(response.status == 200)
              {
                // No cierra el modal aquí: hasta ahora solo se guardó el
                // dato de sobrepeso, falta cobrarlo — el modal se cierra
                // desde payOverWeight() cuando el cobro de verdad termina.
                this.payOverWeight();
              } else {
                this.overWeightSaving = false
                this.overWeightError = 'No se pudo guardar el sobrepeso. Intenta de nuevo.'
              }
          })
          .catch(error => {
            console.error(error)
            this.overWeightSaving = false
            this.overWeightError = 'No se pudo guardar el sobrepeso. Intenta de nuevo.'
          })
    },
    payOverWeight()
    {
        // Fase 2 del plan de monedero: antes no mostraba nada al admin, ni
        // éxito ni error (solo console.log/console.error) — no había forma
        // de saber si el cobro de sobrepeso realmente se aplicó. Mismo
        // patrón de feedback que confirmCredit() en Users.vue.
        axios
          .post(`${commons.apiURL}/api/v1/prepaid/payOverWeight/${this.shipmentId}`, {})
          .then(response => {
              this.overWeightSaving = false
              this.overweight_paid = true
              this.hideModalOverWeight()
              this.message = 'Sobrepeso cobrado correctamente.'
              this.showAlert()
              this.getAllShipmentsByDates()
          })
          .catch(error => {
            console.error(error)
            this.overWeightSaving = false
            const serverMessage = error.response && error.response.data && error.response.data.message
            this.overWeightError = typeof serverMessage === 'string'
              ? serverMessage
              : 'El sobrepeso se guardó, pero no se pudo cobrar del monedero. Intenta de nuevo.'
          })
    },
    formatDate(value) {
      if (value) {
        return moment(String(value)).format('DD/MM/YYYY')
      }
    },
    customFormatter(date) {
         return moment(String(date)).format('DD/MM/YYYY')
    },
    countDownChanged (dismissCountDown) {
      this.dismissCountDown = dismissCountDown
    },
    showAlert () {
      this.dismissCountDown = this.dismissSecs
    },
    gotoShipmentDetails (id) {
      this.$router.push(`/shipments/${id}`)
    },
    gotoShipmentEcommerce(index){
      this.setNewShipmentEcommerce(this.marketplace[index]);
      this.$router.push(`/`)
    },
    previousPage () {
      axios.get(this.shipments.previous).then(response => {
        this.setShipments(response.data)
      })
    },
    nextPage () {
      axios.get(this.shipments.next).then(response => {
        this.setShipments(response.data)
      })
    },
    getAllShipmentsByDates () {
          this.getAllShipmentsPeriod(``);
    },
    onManualDateChange () {
      this.activeDatePreset = null
      this.getAllShipmentsByDates()
    },
    setDateRange (preset) {
      const now = new Date()
      let start
      if (preset === 'today') {
        start = new Date(now.getFullYear(), now.getMonth(), now.getDate())
      } else if (preset === '7d') {
        start = new Date(now.getFullYear(), now.getMonth(), now.getDate() - 6)
      } else if (preset === 'month') {
        start = new Date(now.getFullYear(), now.getMonth(), 1)
      }
      this.date_ini = start
      this.date_fin = now
      this.activeDatePreset = preset
      this.getAllShipmentsByDates()
    },
    goToPage (page) {
      this.getAllShipmentsPeriod(`&limit=10&page=${page}`)
    },
    getAllShipmentsPeriod(page)
    {
      this.searching = true
      this.loadError = false
      var d1 = new Date(this.date_ini);
      var date_ini = [  d1.getFullYear(), d1.getMonth()+1,d1.getDate()]
          .map(n => n < 10 ? `0${n}` : `${n}`).join('-');
      var d2 = new Date(this.date_fin);
      var  date_fin = [  d2.getFullYear(), d2.getMonth()+1,d2.getDate()]
              .map(n => n < 10 ? `0${n}` : `${n}`).join('-');
      axios
        .get(`${commons.apiURL}/api/v1/shipments/period?date_ini=${date_ini}&date_fin=${date_fin}T23:59:59&service=${this.service}&status=${this.status}&filter=${this.searchByKeywordCriteria}${page}`, { timeout: 30000 })
        .then(response => {
          this.setShipments(response.data)
        })
        .catch(error => {
          console.error(error)
          this.loadError = true
        })
        .finally(() => {
          this.dataLoading = false
          this.searching = false
        })
    },
    async actualizaShipmentsExport()
    {

      this.shipmentsExport = [];
      var d1 = new Date(this.date_ini);
      var date_ini = [  d1.getFullYear(), d1.getMonth()+1,d1.getDate()]
          .map(n => n < 10 ? `0${n}` : `${n}`).join('-');
      var d2 = new Date(this.date_fin);
      var  date_fin = [  d2.getFullYear(), d2.getMonth()+1,d2.getDate()]
              .map(n => n < 10 ? `0${n}` : `${n}`).join('-');
     const response = await axios
       .get(`${commons.apiURL}/api/v1/shipments/period?date_ini=${date_ini}&date_fin=${date_fin}T23:59:59&service=${this.service}&status=${this.status}&filter=${this.searchByKeywordCriteria}&limit=100000`);

        /*  this.setGuideStatus([])
         this.getStatusGuide({data:response.data.docs}).then((status)=>{
            this.setGuideStatus(status)
          })*/
        console.log(response.data.count);
        for(var i = 0; i < response.data.count;i++)
        {
          let s = response.data.docs[i];
          let rowExport =
          {
            fecha: this.formatDate(s.created_at),
            usuario: s.customer_info != null ? s.customer_info.first_names + ' ' + s.customer_info.last_names : '',
            correo: s.customer_info != null ? s.customer_info.email : '',
            nombreorigen: s.origin_direction.full_name,
            servicio: s.selected_service.carrier + ' - '+ s.selected_service.carrier_service_name,
            medidas: s.parcels[0].height + ' x ' + s.parcels[0].width + ' x '+ s.parcels[0].depth + ' cm ',
            peso: s.parcels[0].weight,
            guia: this.numberGuide(s.number_guide),
            pagado: s.status ? 'Si': 'No',
          //  estatus_guia: this.obtenerStatus(s.number_guide),
            total: s.selected_service.total_amount
          };
          this.shipmentsExport.push(rowExport);
        }
        return this.shipmentsExport

    },
    availablePages (page) {
      const result = []
      let initial = page > 1 ? page - 1 : 1
      let final = page < this.shipments.pages ? page + 1 : this.shipments.pages

      for (let i = initial; i <= final; i++) {
        result.push(i)
      }

      return result
    },
    deletebadg(i){
      this.filter.splice(i, 1);
    },
    filterShipments (criteria) {
      this.searchByKeywordCriteria = criteria
      this.getAllShipmentsPeriod(``)
    },
    filterShipmentsByGuideStatus (status) {
      this.status = status == 'all' ? '': status
      this.getAllShipmentsPeriod(``)
    },
    getAllAvailableCarriers () {
      api.shipment
        .getAllAvailableCarriers()
        .then(response => {
          this.availableCarriers = response.data

        })
        .catch(error => console.log(error))
    },
    filterShipmentsByCarriersServices (service) {

      this.service = service == 'Servicios' ? '': service
      this.getAllShipmentsPeriod(``)
    },
    downloadTracking (shipment) {
      if (shipment && shipment.guide && /^https?:\/\//i.test(shipment.guide)) {
        return shipment.guide
      }
      const id = shipment && shipment._id ? shipment._id : shipment
      return `https://www.enviosweb.com.mx/api/public/${id}.pdf`
    },

    pmeayntsMany(){

      if (this.statusShipments()) {
        this.showModal()
      } else {
        this.setPaymentShipments(this.selected)
        this.$router.push('/payment/shipments/many')
      }
    },
    filterIsTrue(array_filter){
      let status = true;
      array_filter.forEach(element => {
        if (!element) {
          status = false;
        }
      });
      return status;
    },
    getFilterStatus(items, shipment){
      let list_filter = [];
      items.forEach(item => {
          if (shipment.ecommerce_type === undefined) {

            if (shipment.destination_direction.full_name.toLowerCase().includes(item.toLowerCase())) {
              list_filter.push(true)
            } else if(shipment.destination_direction.address.toLowerCase().includes(item.toLowerCase())){
              list_filter.push(true)
            }else if(shipment.selected_service.carrier_service_name.includes(item)){
              list_filter.push(true)
            }else if(item.toLowerCase() == "true" || item.toLowerCase() === "false") {
              let guide = (item.toLowerCase() == 'true')?true:false
              if (shipment.status === guide) {
                list_filter.push(true)
              }else{
                list_filter.push(false)
              }
            }else{
              list_filter.push(false)
            }
          } else {
            if (shipment.destination_direction.full_name.toLowerCase().includes(item.toLowerCase())) {
              list_filter.push(true)
            } else if(shipment.destination_direction.address.toLowerCase().includes(item.toLowerCase())){
              list_filter.push(true)
            }else {
              list_filter.push(false)
            }
          }
        });
        return list_filter;
    },
    printBadge(text){
      if (text == "true" || text == "false" ) {
        return (text == 'true')?'Pagado':'Guia sin pago'
      } else {
        return text
      }
    },
    ...mapMutations(['setShipments']),
    ...mapActions(['getUser', 'getMarketplace']),
    ...mapMutations(["setPaymentShipments"]),
    ...mapMutations(['setNewShipmentEcommerce'])
  },
  computed: {
   ...mapGetters(['shipments', 'user', "paymentShipments", 'marketplace']),
    isAdmin () {
      return this.user && this.user.rol === 'admin'
    },
    shipmentWithGuide () {
      return []
    },
    shipmentWithoutGuide () {
      return []
    },
    selectAll: {
            get: function () {
                return this.shipments ? this.selected.length == this.shipments.length : false;
            },
            set: function (value) {
                var selected = [];
                if (value) {
                    this.shipments.forEach(function (shipment) {
                        selected.push(shipment);
                    });
                }
                this.selected = selected;
            }
    },
    shipmentsFilter: function(){
      try {
        return this.shipments.filter((shipment)=>{
          return this.filterIsTrue(this.getFilterStatus(this.filter, shipment))
        });
      } catch (error) {
        console.log("this.shipments",this.shipments)
      }

    },
    marketplaceList: function(){
      if (this.key.length > 2) {
        return this.marketplace.filter((item)=>{
          let word = this.key.toLowerCase().trim()
          if(item.destination_direction.full_name.toLowerCase().trim().includes(word)) {
            return true
          }else{
            return false
          }
        })
      } else {
        return this.marketplace
      }

    }
  },
  components: {
    'navbar-dashboard': Navbar,
     Datepicker,
     JsonExcel,
     PhIcon
  },

}

</script>

<style scoped lang="scss">
@import "../assets/styles/app-tokens";
@import "../assets/styles/ew-components";

.ew-page { @include app-tokens; }
.ew-page__body { padding: 1.75rem 2rem 2.5rem; }

.ew-tabs {
  /deep/ .nav-pills {
    border-bottom: 1px solid var(--app-border);
    margin-bottom: 1.5rem;
    .nav-link {
      padding: 0.6rem 0.25rem;
      margin-right: 1.75rem;
      border-radius: 0;
      font-family: var(--app-font);
      font-size: 0.9rem;
      font-weight: 600;
      color: var(--app-muted);
      border-bottom: 2px solid transparent;
      &.active {
        color: var(--app-navy);
        background: transparent;
        border-bottom-color: var(--app-accent);
      }
    }
  }
}

.ew-alert { font-family: var(--app-font); border-radius: var(--app-radius-sm); margin-bottom: 1rem; }
.ew-toolbar { margin-bottom: 1rem; &.ew-toolbar--end { display: flex; justify-content: flex-end; } }
.ew-btn-primary { @include ew-btn-primary; }
.ew-btn-outline { @include ew-btn-outline; }

.ew-card { @include ew-card; margin-bottom: 2rem; }
.ew-filters { padding: 1.1rem 1.25rem; border-bottom: 1px solid var(--app-border); }
.ew-filters__label {
  display: flex; align-items: center; gap: 0.4rem; margin-bottom: 0.75rem;
  font-family: var(--app-font); font-size: 0.8rem; font-weight: 700; color: var(--app-muted);
  svg { width: 0.9rem; height: 0.9rem; }
}
.ew-filters__row-top { display: flex; flex-wrap: wrap; gap: 0.75rem; align-items: center; margin-bottom: 0.75rem; }
.ew-date-range {
  display: flex; align-items: center; gap: 0.5rem;

  /deep/ .vdp-datepicker input {
    @include ew-input;
    width: 8.5rem;
    cursor: pointer;
  }

  /deep/ .vdp-datepicker__calendar {
    font-family: var(--app-font);
    border: 1px solid var(--app-border) !important;
    border-radius: var(--app-radius-md);
    box-shadow: 0 8px 24px rgba(7, 50, 88, .12);
    padding: 0.5rem;

    .cell {
      border-radius: var(--app-radius-sm);
      color: var(--app-navy);

      &:hover:not(.disabled):not(.blank) { border-color: var(--app-accent) !important; background: var(--app-surface-muted); }
      &.today { color: var(--app-accent-button); font-weight: 700; }
      &.selected, &.selected.today { background: var(--app-navy) !important; color: #fff; }
      &.selected:hover { background: var(--app-navy) !important; }
      &.disabled { color: var(--app-border); }
      &.day-header { color: var(--app-muted); font-weight: 700; font-size: 0.75rem; }
    }

    header {
      .prev, .next, .up { color: var(--app-navy); font-weight: 600; }
      .prev:hover:not(.disabled), .next:hover:not(.disabled), .up:hover { background: var(--app-surface-muted); }
    }
  }
}
.ew-date-range__sep { color: var(--app-muted); font-size: 0.85rem; }

.ew-date-presets { display: flex; flex-wrap: wrap; gap: 0.4rem; }
.ew-date-presets__btn {
  border: 1px solid var(--app-border);
  background: #fff;
  border-radius: 999px;
  padding: 0.4rem 0.85rem;
  font-family: var(--app-font);
  font-size: 0.78rem;
  font-weight: 600;
  color: var(--app-muted);
  cursor: pointer;
  &:hover { background: var(--app-surface-muted); }
  &.is-active { background: var(--app-navy); border-color: var(--app-navy); color: #fff; }
}

.ew-filters__row { display: flex; flex-wrap: wrap; gap: 0.75rem; align-items: center; }
.ew-input { @include ew-input; }
.ew-select { @include ew-select; flex: 0 1 12rem; }
.ew-filters__search { position: relative; flex: 1 1 14rem; display: flex; align-items: center; }
.ew-filters__keyword { width: 100%; }
.ew-filters__search-spinner {
  position: absolute;
  right: 0.75rem;
  width: 1rem;
  height: 1rem;
  border: 2px solid var(--app-border);
  border-top-color: var(--app-accent-button);
  border-radius: 50%;
  animation: ew-spin .7s linear infinite;
}
.ew-filters__badges { display: flex; flex-wrap: wrap; gap: 0.5rem; margin-top: 0.9rem; }
.ew-badge { @include ew-badge; }

.ew-table { @include ew-table; }
.ew-loading { @include ew-loading; }
.ew-loading-text { @include ew-loading-text; }
.ew-spinner { @include ew-spinner; }
.ew-table__cell--muted { color: var(--app-muted); font-size: 0.8rem; }
.ew-table__amount { font-weight: 700; &.is-pending { color: var(--app-accent); } &.is-paid { color: #1a7f4f; } }
.ew-table__pdf-link { display: inline-flex; }
.ew-icon-pdf { width: 1.6rem; height: auto; }

.ew-user-cell { display: flex; flex-direction: column; gap: 0.1rem; }
.ew-user-cell__name { font-family: var(--app-font); color: var(--app-navy); }
.ew-user-cell__email { font-size: 0.78rem; color: var(--app-muted); }
.ew-user-cell__id { font-size: 0.78rem; color: var(--app-muted); }

.ew-guide-cell { display: flex; flex-direction: column; gap: 0.15rem; }
.ew-guide-cell__number { font-family: var(--app-font); }
.ew-guide-cell__meta { font-size: 0.72rem; color: var(--app-muted); }

.ew-table__actions { display: flex; gap: 0.4rem; }
.ew-icon-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 2rem;
  height: 2rem;
  flex-shrink: 0;
  border-radius: 50%;
  border: 1px solid var(--app-border);
  background: #fff;
  color: var(--app-navy);
  cursor: pointer;

  svg { width: 1.05rem; height: 1.05rem; }

  &:hover { background: var(--app-surface-muted); }
  &:focus-visible { outline: 3px solid var(--app-accent); outline-offset: 2px; }
}

.ew-empty { @include ew-empty; }
.ew-empty__title { @include ew-empty-title; }
.ew-empty__text { @include ew-empty-text; }

.ew-pagination { display: flex; align-items: center; justify-content: center; gap: 0.4rem; padding: 1rem 1.25rem; border-top: 1px solid var(--app-border); }
.ew-pagination__btn { @include ew-pagination-btn; }

/* Modal editar sobrepeso ------------------------------------------------- */
.ew-form { display: flex; flex-direction: column; gap: 1rem; max-width: none; /* App.vue trae un .ew-form global con max-width:400px legado de los formularios de auth viejos; sin este reset se hereda igual (misma especificidad, propiedades distintas) */ }
.ew-form__field { display: flex; flex-direction: column; gap: 0.4rem; }
.ew-label { font-family: var(--app-font); font-size: 0.8rem; font-weight: 700; color: var(--app-navy); }
.ew-input--block { width: 100%; }
.ew-modal__text { font-family: var(--app-font); color: var(--app-navy-secondary); text-align: left; }
.ew-modal__actions { display: flex; justify-content: flex-end; gap: 0.6rem; }
</style>

<!-- Los modales de bootstrap-vue se montan fuera del árbol scoped. -->
<style lang="scss">
@import "../assets/styles/app-tokens";
.ew-modal {
  .modal-content { border-radius: 0.85rem; border: none; }
  .modal-header { border-bottom: 1px solid $app-border; }
  .modal-title { font-family: $app-font-family; font-weight: 700; color: $app-navy; }
}
</style>



// WEBPACK FOOTER //
// src/components/GeneralReport.vue